import { createFileRoute, notFound } from "@tanstack/react-router";

import { BackendResponseError } from "@/api/backendClient";
import { casesQueries } from "@/api/resources/cases/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import CasePage from "@/components/Case/CasePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/cases/$case_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.cases"),
        icon: <Icon.CASES />,
        path: "/workspaces/$workspace_id/cases",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, case_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentCase = await context.queryClient
      .ensureQueryData(casesQueries.byId(case_id))
      .catch((error: unknown) => {
        // the backend answers 404 for cases that don't exist or aren't visible to the user
        if (error instanceof BackendResponseError && error.status === 404) throw notFound();
        throw error;
      });
    if (!currentCase) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [{ label: currentCase.name, icon: <Icon.CASE /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);

    return currentCase;
  },
  component: CasePage,
});
